import "@Styles/Shared/DoubleClick/thirdPartyProviderContainer_sm.less";
import "@Styles/Shared/DoubleClick/thirdPartyProviderContainer_md.less";
import "@Styles/Shared/DoubleClick/thirdPartyProviderContainer_lg.less";
import AdhesiveAdObserver from './_adhesiveAdObserver';
export default {
  data: function data() {
    return {
      userClosedAd: false,
      settings: {},
      windowWidth: 0,
      ad: null
    };
  },
  methods: {
    init: function init(settings) {
      this.settings = settings || {};
      this.settings.minPageWidth = this.settings.minPageWidth || this.settings.defaultMinPageWidth;
      this.settings.maxPageWidth = this.settings.maxPageWidth || this.settings.defaultMaxPageWidth;
      this.settings.doubleClickAdContainerId = settings.elementId;
      var parent = this.$el.parentElement;

      if (parent && parent.classList.contains('adhesiveAd') && parent.firstElementChild == this.$el) {
        // set the up adhesive ad observer only once
        new AdhesiveAdObserver();
      }
    },
    closeAd: function closeAd() {
      this.userClosedAd = true;
    }
  },
  computed: {
    showAd: function showAd() {
      if (this.settings.responsive) {
        return this.windowWidth >= Number(this.settings.minPageWidth) && this.windowWidth <= Number(this.settings.maxPageWidth) && !this.userClosedAd;
      } else {
        return !this.userClosedAd;
      }
    }
  },
  watch: {
    showAd: function showAd(newVal) {
      debugger;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.windowWidth = window.innerWidth;
    window.addEventListener('resize', function () {
      if (window.innerWidth > 0) _this.windowWidth = window.innerWidth;
    });
  }
};